// import external dependencies
import 'jquery';
import 'alpinejs';
import '@fancyapps/fancybox';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleUsed from './routes/singleUsed';
import singleProduct from './routes/singleProduct';
import checkout from './routes/checkout';
import cart from './routes/checkout';
import taxUsedCat from './routes/taxUsedCat';
import taxProductCat from './routes/taxProductCat';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Used Single
  singleUsed,
  // Product Single
  singleProduct,
  // Checkout page
  checkout,
  // Checkout page
  cart,
  // Used category taxonomy
  taxUsedCat,
  // Product category taxonomy
  taxProductCat,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


/*
  On fancy box open if is a branch tem amember set a hidden field on the form
*/
jQuery(document).ready(() => {
  // Initialize Fancybox
  jQuery('[data-fancybox]').fancybox({
    beforeLoad: function(instance, current) {
      // Access the clicked element
      const clickedElement = current.opts.$orig;

      // Check for a specific data attribute
      if (clickedElement && clickedElement.data('team-member-index')) {
        const teamMemberIndex = clickedElement.data('team-member-index');
        console.log('Team Member Index:', teamMemberIndex);
        if (parseInt(teamMemberIndex) > 0) {
          // Set the index in the current form field - random id set by Ninja forms
          jQuery('#nf-field-193').val(parseInt(teamMemberIndex));
        }
      }
    },
  });

 


  jQuery('.woocommerce-product-gallery' ).each(function() {
    jQuery(this).on('wc-product-gallery-after-init', function() {
      // trigger splide for the product gallery thumbs after WC gallery has initialized
  });
});

});



// WEBPACK FOOTER //
// ./scripts/main.js